// extracted by mini-css-extract-plugin
export default {"cta":"wF-z","disabled":"xF-z"};